const When: React.FC<{ condition: boolean }> = ({ condition, children }) => {
  if (condition) {
    return <>{children}</>;
  } else {
    return null;
  }
};

export default When;
